/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesRiskMatrix.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Risk Matrix Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 05:31:24 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const RiskMatrixList = Loadable({
    loader: () => import('../containers/RiskMatrix/RiskMatrixListContainer'),
    loading: Loading,
});

export const RiskMatrixForm = Loadable({
    loader: () => import('../containers/RiskMatrix/RiskMatrixEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesRiskMatrix.js